// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___dd635b52d82291a2ab2","cls2":"CreateSocialItemModal-cls2___d4943a921f5b1c6629f CreateSocialItemModal-cls1___dd635b52d82291a2ab2"};